/**
 * C1 — mirrors firestore.rules' validMuqriName (firestore.rules:44-49)
 * exactly, so a name the rules will reject is caught here, in the UI, with a
 * message the person can act on — rather than failing later as an
 * unactionable permission-denied on whatever the name is first used for
 * (opening a session, joining a queue).
 *
 * The charset is the STRICTER of the two the rules actually enforce
 * (validMuqriName; the queue's own `name` field only checks length). Every
 * user goes through this one step regardless of which they will become, so
 * validating against the stricter rule up front means neither write path can
 * ever be surprised by a name this step already accepted.
 *
 * Written as literal Unicode ranges, not \p{...} property escapes, because
 * the Firestore rules lexer that owns the canonical version of this pattern
 * rejects property escapes inside a string — keeping the two patterns
 * textually parallel is what makes "mirrors the rules" checkable by eye.
 */
const DISPLAY_NAME_PATTERN =
  // eslint-disable-next-line no-misleading-character-class
  /^[a-zA-Z0-9ؠ-ۿݐ-ݿࢠ-ࣿ،Ā-ſÀ-ÖØ-öø-ÿ '.-]+$/;

export const DISPLAY_NAME_MAX_LENGTH = 60;

export function isValidDisplayName(name: string): boolean {
  return (
    typeof name === 'string'
    && name.length > 0
    && name.length <= DISPLAY_NAME_MAX_LENGTH
    && DISPLAY_NAME_PATTERN.test(name)
  );
}
